import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const LoggedInInfoTriggerButtonTemplate = htmlE`
  <button
    tabindex="0"
    type="button"
    class="primary-button is-bg-none p-0 navbar-item-label"
    aria-label="loggedIn-info-btn">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width="35"
      height="35"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
    <span class="ml-2 text-base username is-hidden-mobile">
      ${"username"}
    </span>
  </button>
`;

const LoggedInInfoTemplate = htmlE`
  <div class="dropdown-content">
    <div class="is-flex is-justify-content-space-between">
    ${({ canShowCustomThemeOption, customThemeText }) => {
      if (canShowCustomThemeOption) {
        return `<button
                id="custom-theme"
                class="primary-button is-bg-none is-bordered"
                aria-label="custom-theme"
              >
                <i class="icon-adjust text-accentMain"></i>
                <span class="text-primaryMain h-6 ml-2"" data-i18n-key="customTheme">${utils.textEncode(
                  customThemeText || ""
                )}</span>
              </button>`;
      }
      return "<div></div>";
    }}
      <button
        id="logout"
        tabindex="0"
        class="primary-button is-bg-none is-bordered"
        aria-label="logout-btn"
      >
        <i class="icon-signout text-accentMain"></i>
        <span class="text-primaryMain h-6 ml-2" data-i18n-key="Logout">${"logoutText"}</span>
      </button>
    </div>
    ${({
      enableUserInformation,
      username,
      loginTime,
      sessionTimeout,
      browserName,
      browserVersion,
      browserInfo,
      hostURL,
      hostName,
      version,
      recentActions,
      canUseWebSocketForUploading,
      canUseWebSocketForDownloading,
      uploadTypeCustomization,
      downloadTypeCustomization,
      informationText,
      loginNameText,
      loginTimeText,
      sessionTimeoutText,
      browserNameText,
      browserVersionText,
      browserInfoText,
      URLText,
      hostNameText,
      versionText,
      recentActionsText,
      socketUploadText,
      socketDownloadText,
      rangeText,
    }) => {
      if (enableUserInformation) {
        return `<h1
        data-i18n-key="information"
        class="profile-info-head-text text-lg has-text-weight-semibold has-text-centered text-primaryMain py-1 my-2"
      >
      ${utils.textEncode(informationText || "")}
      </h1>
      <div class="grid-column-gap">
      <p
        class="has-text-right has-text-weight-semibold text-primaryMain"
      >
        <span data-i18n-key="loginName">${utils.textEncode(
          loginNameText || ""
        )}</span>:
      </p>
      <p class="text-primaryMain profile-info-grid-value">
        ${utils.textEncode(username || "")}
      </p>

      <p
        class="has-text-right has-text-weight-semibold text-primaryMain"
      >
        <span data-i18n-key="loginTime">${utils.textEncode(
          loginTimeText || ""
        )}</span>:
      </p>
      <p class="text-primaryMain profile-info-grid-value">${utils.textEncode(
        loginTime || ""
      )}</p>

      <p
        class="has-text-right has-text-weight-semibold text-primaryMain"
      >
        <span data-i18n-key="sessionTimeout">${utils.textEncode(
          sessionTimeoutText || ""
        )}</span>:
      </p>
      <p
        id="profileSessionInfo"
        class="text-primaryMain profile-info-grid-value"
      >
        ${utils.textEncode(sessionTimeout || "")}
      </p>

      <p
        class="has-text-right has-text-weight-semibold text-primaryMain"
      >
        <span data-i18n-key="browserName">${utils.textEncode(
          browserNameText || ""
        )}</span>:
      </p>
      <p class="text-primaryMain is-capitalized profile-info-grid-value">
        ${utils.textEncode(browserName || "")}
      </p>

      <p
        class="has-text-right has-text-weight-semibold text-primaryMain"
      >
        <span data-i18n-key="browserVersion">${utils.textEncode(
          browserVersionText || ""
        )}</span>:
      </p>
      <p class="text-primaryMain profile-info-grid-value">
        ${utils.textEncode(browserVersion || "")}
      </p>

      <p
        class="has-text-right has-text-weight-semibold text-primaryMain"
      >
        <span data-i18n-key="browserInfo">${utils.textEncode(
          browserInfoText || ""
        )}</span>:
      </p>
      <p class="text-primaryMain profile-info-grid-value">
        ${utils.textEncode(browserInfo || "")}
      </p>

      <p class="has-text-right has-text-weight-semibold text-primaryMain">
        <span data-i18n-key="URL">${utils.textEncode(URLText || "")}</span>:
      </p>
      <p class="text-primaryMain profile-info-grid-value">${utils.textEncode(
        hostURL || ""
      )}</p>

      <p
        class="has-text-right has-text-weight-semibold text-primaryMain"
      >
        <span data-i18n-key="hostName">${utils.textEncode(
          hostNameText || ""
        )}</span>:
      </p>
      <p class="text-primaryMain profile-info-grid-value">${utils.textEncode(
        hostName || ""
      )}</p>

      <p
        class="has-text-right has-text-weight-semibold text-primaryMain"
      >
        <span data-i18n-key="version">${utils.textEncode(
          versionText || ""
        )}</span>:
      </p>
      <p class="text-primaryMain profile-info-grid-value">${utils.textEncode(
        version || ""
      )}</p>

      <p
        class="has-text-right has-text-weight-semibold text-primaryMain"
      >
        <span data-i18n-key="recentActions">${utils.textEncode(
          recentActionsText || ""
        )}</span>:
      </p>
      <p class="text-primaryMain profile-info-grid-value">
        ${utils.textEncode(recentActions || "")}
      </p>

      <p
        class="has-text-right has-text-weight-semibold text-primaryMain"
      >
        <span data-i18n-key="socketUpload">${utils.textEncode(
          socketUploadText || ""
        )}</span>:
      </p>
      <p class="text-primaryMain profile-info-grid-value">
        ${canUseWebSocketForUploading}
      </p>

      <p
        class="has-text-right has-text-weight-semibold text-primaryMain"
      >
        <span data-i18n-key="socketDownload">${utils.textEncode(
          socketDownloadText || ""
        )}</span>:
      </p>
      <p class="text-primaryMain profile-info-grid-value">
        ${canUseWebSocketForDownloading}
      </p>

      <p
        class="has-text-right has-text-weight-semibold text-primaryMain"
      >
        <span data-i18n-key="socketUpload">${utils.textEncode(
          socketUploadText || ""
        )}</span> (<span data-i18n-key="range">${utils.textEncode(
          rangeText || ""
        )}</span>):
      </p>
      <p class="text-primaryMain profile-info-grid-value">
        ${uploadTypeCustomization}
      </p>

      <p
        class="has-text-right has-text-weight-semibold text-primaryMain"
      >
        <span data-i18n-key="socketDownload">${utils.textEncode(
          socketDownloadText || ""
        )}</span> (<span data-i18n-key="range">${utils.textEncode(
          rangeText || ""
        )}</span>):
      </p>
      <p class="text-primaryMain profile-info-grid-value">
        ${downloadTypeCustomization}
      </p>
    </div>`;
      }
      return ``;
    }}
  </div>
</div>`;

export { LoggedInInfoTemplate, LoggedInInfoTriggerButtonTemplate };
